export default __webpack_public_path__ + "static/media/dapp.8a4b971a.png";